<template>
  <div>
    <vuestic-modal ref="openModal"  :large="true">
      <h5 slot="header">Devoluciones a Proveedores</h5>
      <table class="table table-bordered">
        <thead class="thead-dark">
        <tr>
          <th>Folio</th>
          <th>Fecha</th>
          <th>Proveedor</th>
          <th>Usuario</th>
          <th>Transporte</th>
          <th>Código</th>
          <th>Cantidad</th>
          <th>Folio Dcto</th>
          <th>Comentario</th>
          <th>Estado</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="dev in devolucionesC">
          <td>{{dev.folio}}</td>
          <td>{{dev.date | fecha}}</td>
          <td>{{dev.proveedor_nombre.toUpperCase()}}</td>
          <td>{{dev.usuario_nombre.toUpperCase()}}</td>
          <td>{{dev.transporte_nombre.toUpperCase()}}</td>
          <td>{{dev.glosa.codigoProveedor}}</td>
          <td>{{dev.glosa.cantidad}}</td>
          <td>{{dev.glosa.folioDocumento}}</td>
          <td>{{dev.glosa.comentario.toUpperCase()}}</td>
          <td>{{dev.estado.toUpperCase()}}</td>
        </tr>
        </tbody>
      </table>
    </vuestic-modal>
  </div>

</template>
<script>
  import VuesticModal from "../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal";
  import moment from 'moment'
  export default {
    name: 'modalDevolucionesProveedor',
    props: ['devoluciones', 'productoId'],
    components: {VuesticModal},
    methods: {
      openModal() {
        this.$refs.openModal.open()
      }
    },
    filters: {
      fecha: function(value) {
        return moment(value).format('DD/MM/YYYY')
      }
    },
    computed: {
      devolucionesC: {
        get() {
          return this.devoluciones.map(d => {
            return {
              ...d,
              glosa: d.glosa_devolucion.find(item => item.productoId === this.productoId)
            }
          })
        }
      }
    }
  }
</script>
